const Features = () => {
  return (
    <>
      <div id="features" className="text-center overflow-hidden py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl heading mx-auto mb-16">
            <h4 className="text-sm text-indigo-500 font-semibold uppercase tracking-wide">
              Awesome Features
            </h4>
            <h2 className="mt-2 text-3xl sm:text-4xl  text-gray-800 leading-snug">
              Great collection of TTM <br />
              and enjoy our exclusive features
            </h2>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-10">
            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_1.png"}
                alt="Elementor"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Dispatch Manager
              </h6>
            </div>

            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_9.png"}
                alt="WordPress Latest Version"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Load Tracking
              </h6>
            </div>

            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_3.png"}
                alt="One Click Demo Import"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Load Sourcing
              </h6>
            </div>

            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_4.png"}
                alt="Mailchimp"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Fleet Planning
              </h6>
            </div>

            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_5.png"}
                alt="Redux Framework"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Driver/Carrier Pay
              </h6>
            </div>

            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_6.png"}
                alt="Contact Form 7"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Advance CRM
              </h6>
            </div>

            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_7.png"}
                alt="Mega Menu"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Invoice Automation
              </h6>
            </div>

            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_8.png"}
                alt="WPML Compatible"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Fuel, Toll & IFTA
              </h6>
            </div>

            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_10.png"}
                alt="SEO Plugn"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Fleet Management
              </h6>
            </div>

            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_11.png"}
                alt="Unlimited Colors Option"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Fleet Maintenance
              </h6>
            </div>

            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_12.png"}
                alt="Google Font"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Compliance & Safety
              </h6>
            </div>

            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_13.png"}
                alt="Clean Code"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Report & Analytics
              </h6>
            </div>

            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_14.png"}
                alt="Responsive Layout"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Driver App
              </h6>
            </div>

            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_15.png"}
                alt="Speed Optimized"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Agency Manager
              </h6>
            </div>

            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_16.png"}
                alt="Easy to Customize"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Carrier Bidding
              </h6>
            </div>
            <div className="flex flex-col items-center shadow space-y-3">
              <img
                src={"assets/icon_9.png"}
                alt="Support Jetpack"
                className="w-16 h-16 object-contain"
              />
              <h6 className="text-base font-medium text-gray-700">
                Carrier Onboarding
              </h6>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Features;
